import React, { useState, createContext, useEffect, useRef } from "react";

import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast } from "../utils/ToastUtil";
import useSessionTimeout from "../hooks/useSessionTimeout";
import useLogoutOnClose from "../hooks/useLogoutOnClose";

const AuthContext = createContext({
  token: "",
  nepalToken: "",
  user: "",
  nepalUser: "",
  ifDocsUploaded: "",
  location: "",
  isLoggedIn: false,
  login: (token) => {},
  saveUser: (user) => {},
  saveNepalUser: (user) => {},
  logout: () => {},
  setLocation: (lat, long) => {},
});

export const AuthContextProvider = (props) => {
  const initialToken = localStorage.getItem("access_token");
  const initialNepalToken = localStorage.getItem("nepal_token");
  const initialUser = JSON.parse(localStorage.getItem("user"));
  const initialNepalUser = JSON.parse(localStorage.getItem("user_nepal"));
  const docsData = JSON.parse(localStorage.getItem("docs"));

  const [token, setToken] = useState(initialToken);
  const [nepalToken, setNepalToken] = useState(initialNepalToken);
  const [user, setUser] = useState(initialUser);
  const [nepalUser, setNepalUser] = useState(initialNepalUser);
  const [location, setLocation] = useState(
    JSON.parse(localStorage.getItem("location"))
  );
  const [ifDocsUploaded, setIfDocsUploaded] = useState(docsData);
  const [theame, setTheame] = useState();
  const [iconColor, setIconColor] = useState();
  const [currentView, setCurrentView] = useState(null);
  const [ip, setIp] = useState("");
  const [dmt2Doc, setDmt2Doc] = useState("");
  const [value, setValue] = useState(0);
  const isUserNavigatingAway = useRef(false);
  const userIsLoggedIn = !!token;

  const loginHandler = (token) => {
    setToken(token);
    localStorage.setItem("access_token", token);
  };

  const nepalTokenSetter = (token) => {
    setNepalToken(token);
    localStorage.setItem("nepal_token", token);
  };

  const userHandler = (passedUser) => {
    localStorage.setItem("user", JSON.stringify(passedUser));
    setUser(passedUser);
  };

  const nepalUserHandler = (passedUser) => {
    localStorage.setItem("user_nepal", JSON.stringify(passedUser));
    setNepalUser(passedUser);
  };

  const logOutFromApi = () => {
    postJsonData(
      ApiEndpoints.LOGOUT,
      {},
      null,
      (res) => {
        console.log("logout");
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  const logOutHandler = () => {
    logOutFromApi();
    setToken(null);
    setUser(null);
    
    localStorage.removeItem("access_token");
    localStorage.removeItem("aepsType");
    localStorage.removeItem("user");
    localStorage.removeItem("user_nepal");
    localStorage.removeItem("nepal_token");
    localStorage.removeItem("location");
    localStorage.removeItem("docs");
    localStorage.removeItem("MoneyTransfer");
  };

  const latLongHandler = (lat, long) => {
    setLocation({ lat, long });
    localStorage.setItem("location", JSON.stringify({ lat, long }));
  };

  const setDocsInLocal = (options) => {
    localStorage.setItem("docs", JSON.stringify(options));
    setIfDocsUploaded(options);
  };

  useSessionTimeout(logOutHandler, 1800000);
  // useLogoutOnClose(logOutHandler);

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = ""; // This shows the "Reload or Cancel" dialog
  //   };

  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "hidden") {
  //       setTimeout(() => {
  //         if (document.visibilityState === "hidden") {
  //           logOutHandler(); // Call logout function when tab is closed
  //         }
  //       }, 1000);
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);


  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     console.log("Before unload event triggered", event.returnValue);
  //     event.returnValue = ""; // This triggers the confirmation dialog
  //     isUserNavigatingAway.current = true;
  //   };

  //   const handleUnload = () => {
  //     if (!isUserNavigatingAway.current) {
  //       logOutHandler(); // Call logout function
  //       isUserNavigatingAway.current = true;
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   window.addEventListener("unload", handleUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);
 const contextValue = {
    token: token,
    nepalToken: nepalToken,
    user: user,
    nepalUser: nepalUser,
    location: location,
    isLoggedIn: userIsLoggedIn,
    currentView: currentView,
    setCurrentView: setCurrentView,
    login: loginHandler,
    nepalTokenSetter: nepalTokenSetter,
    logout: logOutHandler,
    saveUser: userHandler,
    setTheame: setTheame,
    setIconColor: setIconColor,
    theame: theame,
    iconColor: iconColor,
    saveNepalUser: nepalUserHandler,
    setLocation: latLongHandler,
    setDocsInLocal,
    ifDocsUploaded,
    setValue:setValue,
    value:value,
    setIp:setIp,
    ip:ip,
    setDmt2Doc:setDmt2Doc,
    dmt2Doc:dmt2Doc
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
